<template>
    <div class="form-group mapContainer">
        <p class="form-text text-muted mb-1">
            Verificati daca pozitia pin-ului este corecta pe Google Maps (puteti folosi mouse-ul pentru a ajuta pozitia)
        <p/>
        <input type="text" :readonly="readonly" ref="autocomplete" class="form-control mb-2" name="inputSearchAddress" placeholder="" v-model="inputSearchAddress">
        <div class="google-map" ref="googleMap" v-bind:style="{ width: '100%', height: '400px' }"></div>
        <input type="hidden" class="" name="lat" v-if="coordinates" v-model="coordinates[0]">
        <input type="hidden" class="" name="lng" v-if="coordinates" v-model="coordinates[1]">
    </div>
</template>

<script>
    import { Loader } from '@googlemaps/js-api-loader'

    export default {
        props: {
            readonly: Boolean,
            apiKey: String,
            mapCoordinates: Array,
            searchAddress: String
        },
        data () {
            return {
                inputSearchAddress: this.searchAddress ,
                mapConfig: {
                    center: { lat: 45, lng: 23 },
                    zoom: 6
                },
                google: null,
                map: null,
                coordinates: this.mapCoordinates,
                marker: null
            }
        },
        async mounted () {
            new Loader({
                apiKey: this.apiKey,
                version: "weekly",
                libraries: ["places"]
            }).load()
                .then(() => {
                    this.google = google;
                    this.initializeMap()
                })
                .catch(e => {
                    console.log(e)
                });
        },

        methods: {
            initializeMap () {
                const mapContainer = this.$refs.googleMap
                this.map = new this.google.maps.Map(mapContainer, this.mapConfig)

                this.marker = new this.google.maps.Marker({
                    map: this.map,
                    anchorPoint: new this.google.maps.Point(0, -29),
                    draggable: !this.readonly,
                    label: '',
                    optimized: false,
                    visible: false
                })
                if (!this.readonly) {
                    this.marker.addListener('dragend', () => {
                        this.$set(this.coordinates, 0, this.marker.getPosition().lat())
                        this.$set(this.coordinates, 1, this.marker.getPosition().lng())
                    })
                }
                this.loadAutocomplete()
                if (this.coordinates !== null) {
                    const myLatlng = new this.google.maps.LatLng(this.coordinates[0], this.coordinates[1])
                    this.loadMarker(myLatlng)
                }
            },
            loadMarker (myLatlng) {
                this.marker.setVisible(true)
                this.marker.setPosition(myLatlng)
                this.map.setCenter(myLatlng)
                this.map.setZoom(17)
            },
            loadAutocomplete () {
                const autocomplete = new this.google.maps.places.Autocomplete(this.$refs.autocomplete)
                autocomplete.setTypes([])
                autocomplete.bindTo('bounds', this.map)

                autocomplete.addListener('place_changed', ()  => {
                    const place = autocomplete.getPlace()
                    if (!place.geometry) {
                        return
                    }

                    if (place.geometry.viewport) {
                        this.map.fitBounds(place.geometry.viewport)
                    }
                    this.coordinates = [];
                    this.$set(this.coordinates, 0, place.geometry.location.lat())
                    this.$set(this.coordinates, 1, place.geometry.location.lng())

                    this.loadMarker(place.geometry.location)
                })
            }
        }
    }
</script>
